import { getQueryParams } from "neetocommons/utils";

export const getInitialSearchValue = ({
  initialValue = "",
  enableUrlSync,
  searchParamName,
}) => {
  if (enableUrlSync) {
    const queryParams = getQueryParams({ toCamelCase: false });

    return queryParams[searchParamName] ?? "";
  }

  return initialValue;
};
